export const state = {
    exchangesCountOnPage: 20,
    exchanges: [],
    totalExchangesCount: null,
    filters: {
        status: [],
    },
};
